import React from 'react';

export default function Loader() {
  return (
    <div role="status" aria-label="Loading..." className="spinner">
      <div className="spinner-1"></div>
      <div className="spinner-2"></div>
      <div className="spinner-1"></div>
    </div>
  );
}
